import { ReactNativeFile } from "apollo-upload-client"
import { BuildConfiguration } from "../services/platform-info/build-configuration"

export interface SelectedItemImage {
	uri: string
	name: string
	type: string
	file?: File
}

const defaultMimeType = "image/jpeg"

const guessMimeFromExtension = (extension?: string) => {
	if (!extension) {
		return defaultMimeType
	}

	switch (extension.toLowerCase()) {
	case "jpg":
	case "jpeg":
		return "image/jpeg"
	case "png":
		return "image/png"
	case "gif":
		return "image/gif"
	case "webp":
		return "image/webp"
	default:
		return defaultMimeType
	}
}

export const guessImageMimeType = (value?: string, fallback?: string) => {
	if (!value) {
		return fallback ?? defaultMimeType
	}

	const extension = value.split(".").pop()

	return guessMimeFromExtension(extension)
}

export const createItemImageUpload = (image?: SelectedItemImage | null) => {
	if (!image) {
		return undefined
	}

	if (image.file) {
		return image.file
	}

	return new ReactNativeFile({
		uri: image.uri,
		name: image.name,
		type: image.type || guessImageMimeType(image.name),
	})
}

export const getDoorhubFileUrl = (fileId?: string | null) => {
	if (!fileId) {
		return null
	}

	const baseUrl = (BuildConfiguration.DOORHUB_HOST || "").replace(/\/+$/, "")
	return `${baseUrl}/api/file/${fileId}`
}
